import merge from "lodash/merge"

class ConfHotel {
  constructor() {
    this.id = 0
    this.name = ""
    this.introduction = ""
    this.url = ""
    this.address = ""
    this.conference_id = 0
    this.create_time = new Date()
  }
  static getList(filters) {
    const url = process.env.VUE_APP_API_URL + "api/v1/hotel"
    if (!filters.per_page || filters.per_page == "") {
      filters.per_page = -1
    }
    return axios.get(url, { params: filters }).then((res) => {
      let returndata = {}
      returndata.result = []
      let c = new ConfHotel()
      res.data.forEach((x) => {
        let c = new ConfHotel()
        Object.assign(c, x)
        returndata.result.push(c)
      })
      return returndata
    })
  }

  static async get_by_id(hotel_id){
    const res = await ConfHotel.getList({id: hotel_id})
    return res.result[0]
  }
}
export { ConfHotel }
